<div class="row no-gutters"
     *ngIf="distributionJobList">

    <mat-accordion class="full-width">
        <mat-expansion-panel class="mt-2"
                             *ngFor="let job of distributionJobList.items; let idx = index"
                             [ngClass]="{ 'has-error': job.state === DistributionJobState.ERROR_PREPARING || job.state === DistributionJobState.ERROR_SENDING }"
                             [expanded]="activeDistributionJob && activeDistributionJob.id === job.id"
                             id="{{idPrefix}}job_{{idx}}">
            <mat-expansion-panel-header (click)="selectDistributionJob(job)">

                <mat-panel-title>
                    <div class="row full-width align-items-end">
                        <div class="col-1" align="middle">
                            <i *ngIf="job.state !== DistributionJobState.SENDING_SCHEDULED"
                               class="{{ getJobStateIcon(job) }}"
                               [matTooltip]="job.getTooltip() | translate">
                            </i>
                            <mat-spinner *ngIf="job.state === DistributionJobState.SENDING_SCHEDULED"
                                         matListAvatar [diameter]="18">
                            </mat-spinner>
                        </div>

                        <div class="col-5">
                            <span>{{ job.receiver?.displayName ? (job.receiver.displayName | uppercase) : '' }}</span>
                        </div>

                        <div class="col-2">
                            <span>{{ getChannelTranslationKey(job.channel) | translate | uppercase }}</span>
                        </div>

                        <div class="col-4 small-font text-right">
                            <span *ngIf="job.state === DistributionJobState.SENT && job.finished_by">
                                {{ job.finished_by }} {{ 'common.label.on' | translate }} {{ job.distribution_date ? ': ' + (job.distribution_date | drDateTime) : '' }}
                            </span>
                        </div>
                    </div>
                </mat-panel-title>

            </mat-expansion-panel-header>

            <distribution-job #djc
                              *ngIf="activeDistributionJob && activeDistributionJob.id === job.id && distributionChannels && receiverList"
                              class="full-width"
                              [idPrefix]="(idPrefix + 'selected.')"
                              [bananaBox]="activeDistributionJob"
                              (bananaBoxChange)="updateActiveDistributionJob($event, true)"
                              [channels]="distributionChannels"
                              [receivers]="receiverList.items"
                              (cancel)="deleteDistribution($event)"
                              (copy)="copyDistribution($event)"
                              (prepare)="prepareDistribution($event)"
                              (signNow)="signDistribution($event)"
                              (send)="sendDistribution($event)"
                              (onCdkFileDropped)="fileDropped($event)"
                              (onOpenTemplatesDialog)="openTemplatesDialog()">
            </distribution-job>

        </mat-expansion-panel>
    </mat-accordion>

</div>
